import { render, staticRenderFns } from "./UkrposhtaProduct.vue?vue&type=template&id=4e52c783&scoped=true"
import script from "./UkrposhtaProduct.vue?vue&type=script&lang=js"
export * from "./UkrposhtaProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52c783",
  null
  
)

export default component.exports